<div class="d-flex" style="height: 100%;">
    <div *ngIf="!ui?.noData" class="d-flex" style="width: 100%; overflow: auto; justify-content: flex-start;">
        <ng-container *ngIf="ui?.data; let data;">
            <ng-container *ngIf="!_settings?.hideInit">
                <ng-container
                    *ngTemplateOutlet="column; context: {levels: ui?.numRows, name: '-', header: null, init: true}">
                </ng-container>
            </ng-container>
            <ng-container *ngFor="let header of data; let headerIdx = index; trackById">
                <ng-container *ngIf="!_settings.headerLimit || headerIdx < _settings.headerLimit">
                    <ng-container
                        *ngTemplateOutlet="column; context: {levels: header.levels, name: header.name, header: header}">
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
    <div *ngIf="ui?.noData" class="d-flex justify-content-center align-items-center" style="width: 100%">
        {{ ui?.noDataMsg | translate }}
    </div>
</div>

<ng-template #column let-levels="levels" let-header="header" let-name="name" let-init="init">
    <div class="d-flex flex-column column-container" style="margin-top: -0.5em">
        <ng-template #headerName>
            <div *ngIf="!_settings.hideHeader"
                [ngClass]="{'chart-col-2-header': !_settings.shortHeader, 'chart-col-2': !_settings.headerLimit, 'chart-col-2-small': _settings.headerLimit}"
                (click)="onChartClicked({name: 'header', header: header})" [title]="name">
                {{name}}
            </div>
        </ng-template>
        <ng-template #headerSum>
            <div *ngIf="_settings.showSum"
                [ngClass]="{'chart-col-2': !_settings.headerLimit, 'chart-col-2-small': _settings.headerLimit}"
                (click)="onChartClicked({name: 'sum', header: header})" [title]="header?.sum">
                {{header?.sum}}
            </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="_settings.flipHeader ? headerName : headerSum"></ng-container>
        <div class="chart-col-2-container">
            <ng-container *ngFor="let row of levels; let idx = index; trackById">
                    <div [ngClass]="{'chart-col-2': !_settings.headerLimit, 'chart-col-2-small': _settings.headerLimit}" [ngStyle]="{
                        'color': init ? 'black' : 'white',
                        'text-shadow': init ? 'none' : '1px 2px 3px #0000007e',
                        'background-color': !init ? row.color : '',
                        'opacity': !row.count && !init ? '50%' : '1'
                    }"
                        (click)="onChartClicked({name: 'level', header: header, level: row})">
                        {{init ? row : row.count}}
                    </div>
            </ng-container>
        </div>
        <ng-container *ngTemplateOutlet="_settings.flipHeader ? headerSum : headerName"></ng-container>
    </div>
</ng-template>
